import { render, staticRenderFns } from "./WorkIconNavHolidays.vue?vue&type=template&id=19c15929"
import script from "./WorkIconNavHolidays.vue?vue&type=script&lang=js"
export * from "./WorkIconNavHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports